import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const DetailsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px;
	gap: 10px;
	width: 100%;
	max-width: 1209px;
	background: #ffffff;
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const Row = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 31px;
	width: 100%;
	height: 50px;
`;

const Col = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 14px;
`;

const Label = styled.div`
	font-family: 'Inter', sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
	color: #0c0c0c;
`;

const Value = styled.div`
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	font-size: 16px;
	line-height: 19px;
	color: #000000;
`;

const StatusValue = styled(Value)`
	color: ${(props) => (props.status === 'Active' ? '#05C725' : '#FF3B30')};
`;

export default function BusinessUnitDetailsBox({ buName, buCode, openFrom, status }) {
	return (
		<DetailsContainer>
			<Row>
				<Col>
					<Label>BU Name</Label>
					<Value>{buName}</Value>
				</Col>
				<Col>
					<Label>BU Code</Label>
					<Value>{buCode}</Value>
				</Col>
				<Col>
					<Label>Open From</Label>
					<Value>{openFrom}</Value>
				</Col>
				<Col>
					<Label>Status</Label>
					<StatusValue status={status}>{status}</StatusValue>
				</Col>
			</Row>
		</DetailsContainer>
	);
}

BusinessUnitDetailsBox.propTypes = {
	buName: PropTypes.string.isRequired,
	buCode: PropTypes.string.isRequired,
	openFrom: PropTypes.string.isRequired,
	status: PropTypes.string.isRequired,
};
